import { render } from "./json-builder.vue?vue&type=template&id=2c80d33f&scoped=true"
import script from "./json-builder.vue?vue&type=script&lang=js"
export * from "./json-builder.vue?vue&type=script&lang=js"

import "./json-builder.vue?vue&type=style&index=0&id=2c80d33f&scoped=true&lang=css"
import "./json-builder.vue?vue&type=style&index=1&id=2c80d33f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c80d33f"]])

export default __exports__